export const LOGBOOK_LOADED = 'logbook.LOADED';

export const LOGBOOK_FETCH_UPDATED_BY_BOOKKEEPER = 'logbook.FETCH_UPDATED_BY_BOOKKEEPER';
export const LOGBOOK_FETCH_UPDATED_BY_SYSTEM = 'logbook.FETCH_UPDATED_BY_SYSTEM';
export const LOGBOOK_UPDATE_SALESLOG_FOR_DATE = 'logbook.UPDATE_SALESLOG_FOR_DATE';
export const LOGBOOK_UPDATE_PURCHASES_LOG_FOR_DATE = 'logbook.UPDATE_PURCHASES_LOG_FOR_DATE';
export const LOGBOOK_UPDATE_GENERAL_LOG_FOR_DATE = 'logbook.UPDATE_GENERAL_LOG_FOR_DATE';
